import { TranslationsContext } from '@teliaee/telia-translate';
import * as React from 'react';
import { MediaQueryWrapper } from '@teliaee/telia-common-components';
import { TProps as JSXParserProps } from 'react-jsx-parser';
import {
  Accordion,
  AccordionContent,
  AccordionHeader,
  AccordionItem,
  AccordionTitle,
  AnalyticsProvider,
  AnalyticsTrigger,
  Anchor,
  ArrowList,
  ArrowListItem,
  Autoscroll,
  Badge,
  Banner,
  BannerHeading,
  BannerItem,
  Button,
  Card,
  CardBottom,
  CardContent,
  CardFooter,
  CardHeader,
  CardTop,
  Carousel,
  CarouselItem,
  CarouselHero,
  CarouselHeroItem,
  ChartBarHorizontal,
  ClickArea,
  ClickAreaTrigger,
  Collapse,
  CollapseLayer,
  CollapseLayerGrid,
  CollapseLayerProvider,
  CollapseProvider,
  CollapseToggle,
  CollapseTrigger,
  Container,
  Countdown,
  Dropdown,
  EqualHeight,
  EqualHeightProvider,
  EuIcon,
  FeatureList,
  FeatureListItem,
  Fittext,
  Grid,
  GridCollapse,
  GridCollapseProvider,
  GridCollapseTrigger,
  GridColumn,
  HashTrigger,
  HeaderMegamenuBanner,
  Heading,
  Icon,
  Iframe,
  Image,
  InternetSpeed,
  Lightbox,
  LightboxProvider,
  LightboxTrigger,
  List,
  ListItem,
  Modal,
  ModalCloser,
  ModalContent,
  ModalProvider,
  ModalTrigger,
  Notice,
  ObjectFit,
  Pebble,
  ProcessList,
  ProcessListItem,
  ProductCard,
  Section,
  SectionImage,
  Separator,
  ServiceCards,
  ServiceCardsItem,
  TabCordion,
  Table,
  TableCell,
  TableRow,
  TabModal,
  TabModalItem,
  Tabs,
  TabsItem,
  Tag,
  Text,
  TextField,
  Tooltip,
  TooltipToggle,
  UserAgent,
  Video,
} from 'telia-front-react';
import AddressAutocomplete from '../address/AddressAutocomplete';
import ServiceNumbers from '../billing/ServiceNumbers';
import Blacklist from '../blacklist/Blacklist';
import { Count } from '../components/Count';
import config from '../Config';
import ErrorUtil from '../error/ErrorUtil';
import GravityForm from '../forms/GravityForm';
import MeluCalculator from '../melu/MeluCalculator';
import MobileBusinessPackageSelection from '../mobilebusiness/MobileBusinessPackageSelection';
import MobileLifeVolumeSelectors from '../mobileprivate/MobileLifeVolumeSelectors';
import PrivateMobileCards from '../mobileprivate/PrivateMobileCards';
import Ms365PackageComparison from '../ms365/Ms365PackageComparison';
import PersonalOffers from '../offer/PersonalOffers';
import ProposalContent from '../offer/proposals/ProposalContent';
import PostpayCalculator from '../postpay/PostpayCalculator';
import PriceListComponent from '../pricelist/PriceListComponent';
import HasProduct from '../product/HasProduct';
import InternetAddressSearch, { default as InternetAndTvAddressSearch } from '../product/internetAndTvCalculator/InternetAddressSearch';
import InternetCalculator, { default as InternetAndTvCalculator } from '../product/internetAndTvCalculator/InternetCalculator';
import RequestFasterInternet from '../product/internetAndTvCalculator/RequestFasterInternet';
import ReservationAdministration from '../reservation/administration/ReservationAdministration';
import { BranchDetails } from '../reservation/branchdetails/BranchDetails';
import Reservation from '../reservation/Reservation';
import BranchReservationButton from '../reservation/shopinformation/BranchReservationButton';
import CancelReservation from '../reservation/CancelReservation';
import RequestCallback from '../reservation/callback/RequestCallback';
import CityBranchesTabs from '../reservation/shopinformation/CityBranchesTabs';
import SmsLink from '../roaming/packages/SmsLink';
import RoamingCountrySearch from '../roaming/RoamingCountrySearch';
import RoamingNumberResults from '../roaming/RoamingNumberResults';
import RoamingNumberSearch from '../roaming/RoamingNumberSearch';
import RoamingResults from '../roaming/RoamingResults';
import SafeCalculator from '../safe/SafeCalculator';
import SiteSearch from '../search/SiteSearch';
import SecureInternet from '../securenet/SecureInternet';
import ServicePreviewArea from '../service/ServicePreviewArea';
import IsB2B from '../sso/IsB2B';
import IsB2C from '../sso/IsB2C';
import LoggedIn from '../sso/LoggedIn';
import LoggedOut from '../sso/LoggedOut';
import LogInAnchor from '../sso/LogInAnchor';
import LogInButton from '../sso/LogInButton';
import StartingCompanyCalculator from '../startingcompany/StartingCompanyCalculator';
import TradeInComponent from '../tradein/TradeInComponent';
import { Go3AppCards } from '../tv/go3/Go3AppCards';
import ChannelGuide from '../tv/guide/ChannelGuide';
import MovieRental from '../tv/MovieRental';
import TvB2BPacketDetailsContainer from '../tv/TvB2BPacketDetailsContainer';
import TvChannelComparisonContainer from '../tv/TvChannelComparisonContainer';
import TvComparisonContainer from '../tv/TvComparisonContainer';
import { default as TvPackageOfferingCards } from '../tv/TvPackageOfferingCardsContainer';
import { TvPackageOfferingCarouselContainer as TvPackageOfferingCarousel } from '../tv/TvPackageOfferingCarouselContainer';
import TvSearch from '../tv/TvSearch';
import TvTop from '../tv/TvTop';
import DomainSearch from '../whois/DomainSearch';
import ABTestWrapperOptimizely from '../wrapper/ABTestWrapperOptimizely';
import CommonComponentsProviderWrapper from '../wrapper/CommonComponentsProviderWrapper';
import HasParam from '../wrapper/HasParam';
import RedirectToSegment from '../wrapper/RedirectToSegment';
import AdditionalInformation from './AdditionalInformation';
import AdditionalInformationItem from './AdditionalInformationItem';
import BusinessTvPacketsContainer from './BusinessTvPacketsContainer';
import ClientSupport from './ClientSupport';
import ContentFooter from './ContentFooter';
import CustomerService from './CustomerService';
import CyberSecurityCalculator from './CyberSecurityCalculator';
import ExtendedJsxParser from './ExtendedJsxParser';
import FeedDigitark from './FeedDigitark';
import FixInternetCalculator from './FixInternetCalculator';
import FreeTrialMotivators from './FreeTrialMotivators';
import FreeTrialMotivatorsItem from './FreeTrialMotivatorsItem';
import FrontPageCarousel from './FrontPageCarousel';
import GaPushOnMount from './GaPushOnMount';
import { Go3UpsellBanner } from './Go3UpsellBanner';
import GoodToKnow from './GoodToKnow';
import HasCampaign from './HasCampaign';
import Hero from './Hero';
import InsuranceCalculator from './InsuranceCalculator';
import JobOffers from './JobOffers';
import Marketing from './Marketing';
import News from './News';
import NewsDetailsContainer from './NewsDetailsContainer';
import NewsList from './NewsList';
import Packages from './Packages';
import ProductsWrapper from './ProductsWrapper';
import RelatedServices from './RelatedServices';
import SecureInternetCalculator from './SecureInternetCalculator';
import ServiceNotification from './ServiceNotification';
import SignalMap from './SignalMap';
import SplitBanner from './SplitBanner';
import TabHero from './TabHero';
import Telia1Benefits from './Telia1Benefits';
import TvChannelList from './TvChannelList';
import TvRecordableChannels from './TvRecordableChannels';
import { ConstructorPortal } from '../constructorportal/ConstructorPortal';
import { IsHardAuthOrDealer } from '../sso/IsHardAuthOrDealer';
import { IsNotHardAuthOrDealer } from '../sso/IsNotHardAuthOrDealer';

interface JsxRendererProps extends JSXParserProps {
  jsx: string;
  doNotScroll?: boolean;
  onError?: () => void;
  showErrorNotice?: boolean;
}

interface JsxRendererState {
  errored: boolean;
}

class JsxRenderer extends React.Component<JsxRendererProps, JsxRendererState> {
  static contextType = TranslationsContext;
  declare context: React.ContextType<typeof TranslationsContext>;

  private readonly webComponents = {
    AdditionalInformation,
    AdditionalInformationItem,
    AddressAutocomplete,
    Blacklist,
    BranchDetails,
    BranchReservationButton,
    BusinessTvPacketsContainer,
    CancelCallback: CancelReservation,
    ChannelGuide,
    CityBranchesTabs,
    ClientSupport,
    ContentFooter,
    ConstructorPortal,
    Countdown,
    CustomerService,
    CyberSecurityCalculator,
    DomainSearch,
    FeedDigitark,
    FreeTrialMotivators,
    FreeTrialMotivatorsItem,
    FrontPageCarousel,
    GaPushOnMount,
    Go3AppCards,
    Go3UpsellBanner,
    GoodToKnow,
    GravityForm,
    HasCampaign,
    HasParam,
    HasProduct,
    Hero,
    InsuranceCalculator,
    InternetAndTvAddressSearch,
    InternetAddressSearch,
    InternetAndTvCalculator,
    InternetCalculator,
    IsB2B,
    IsB2C,
    IsHardAuthOrDealer,
    IsNotHardAuthOrDealer,
    JobOffers,
    LogInAnchor,
    LogInButton,
    LoggedIn,
    LoggedOut,
    Marketing,
    MeluCalculator,
    MobileBusinessPackageSelection,
    MobileLifeVolumeSelectors,
    MobileRecommendationsContent: ProposalContent,
    ProposalContent,
    MovieRental,
    Ms365PackageComparison,
    News,
    NewsDetailsContainer,
    NewsList,
    Packages,
    PersonalOffers,
    PrivateMobileCards,
    ProductsWrapper,
    RedirectToSegment,
    RelatedServices,
    RequestCallback,
    RequestFasterInternet,
    Reservation,
    ReservationAdministration,
    RoamingCountrySearch,
    RoamingNumberResults,
    RoamingNumberSearch,
    RoamingResults,
    SafeCalculator,
    SecureInternet,
    SecureInternetCalculator,
    ServiceNumbers,
    ServicePreviewArea,
    SignalMap,
    SiteSearch,
    SmsLink,
    SplitBanner,
    StartingCompanyCalculator,
    TradeInComponent,
    TvB2BPacketDetailsContainer,
    TvChannelComparisonContainer,
    TvChannelList,
    TvRecordableChannels,
    TvComparisonContainer,
    TvPackageOfferingCards,
    TvPackageOfferingCarousel,
    TvSearch,
    TvTop,
    TabHero,
    CommonComponentsProviderWrapper,
    Count,
    Telia1Benefits,
    ABTestWrapperOptimizely,
    FixInternetCalculator,
    PriceListComponent,
    ServiceNotification,
    MediaQueryWrapper,
  };

  public constructor(props: JsxRendererProps) {
    super(props);
    this.state = { errored: false };
  }

  public componentDidUpdate = (prevProps: Readonly<JsxRendererProps>) => {
    if (this.props.jsx !== prevProps.jsx && this.state.errored) {
      this.setState({ errored: false });
    }
  };

  public shouldComponentUpdate(nextProps: JsxRendererProps, nextState: JsxRendererState): boolean {
    return nextProps.jsx !== this.props.jsx || this.state.errored !== nextState.errored;
  }

  public componentDidMount() {
    if (this.props.doNotScroll !== true) {
      window.scrollTo(0, 0);
    }
  }

  private renderError = () => {
    const translate = this.context.translate;
    return (
      <Container>
        <Separator spacing="large" color="invisible" />
        <Notice type="error">{translate('general.error.message')}</Notice>
        <Separator spacing="large" color="invisible" />
      </Container>
    );
  };

  private handleError = (e: Error) => {
    this.setState({ errored: true });
    const jsxError = new Error(`JSX render failed on ${window.location.pathname}`);
    jsxError.stack = e.stack;
    ErrorUtil.pushErrorToTeliaRumAndLog(jsxError);
  };

  public render() {
    if (this.state.errored && this.props.showErrorNotice) {
      return this.renderError();
    }

    return (
      // @ts-ignore
      <ExtendedJsxParser
        components={{
          ...this.webComponents,
          Accordion,
          AccordionContent,
          AccordionHeader,
          AccordionItem,
          AccordionTitle,
          AnalyticsProvider,
          AnalyticsTrigger,
          Anchor,
          ArrowList,
          ArrowListItem,
          Autoscroll,
          Badge,
          Banner,
          BannerHeading,
          BannerItem,
          Button,
          Card,
          CardBottom,
          CardContent,
          CardFooter,
          CardHeader,
          CardTop,
          Carousel,
          CarouselItem,
          CarouselHero,
          CarouselHeroItem,
          ChartBarHorizontal,
          ClickArea,
          ClickAreaTrigger,
          Collapse,
          CollapseLayer,
          CollapseLayerGrid,
          CollapseLayerProvider,
          CollapseProvider,
          CollapseToggle,
          CollapseTrigger,
          Container,
          Dropdown,
          EqualHeight,
          EqualHeightProvider,
          EuIcon,
          FeatureList,
          FeatureListItem,
          Fittext,
          Grid,
          GridCollapse,
          GridCollapseProvider,
          GridCollapseTrigger,
          GridColumn,
          HashTrigger,
          HeaderMegamenuBanner,
          Heading,
          Icon,
          Iframe,
          Image,
          InternetSpeed,
          Lightbox,
          LightboxProvider,
          LightboxTrigger,
          List,
          ListItem,
          Modal,
          ModalCloser,
          ModalProvider,
          ModalTrigger,
          ModalContent,
          Notice,
          ObjectFit,
          Pebble,
          PostpayCalculator,
          ProcessList,
          ProcessListItem,
          ProductCard,
          Section,
          SectionImage,
          Separator,
          ServiceCards,
          ServiceCardsItem,
          TabCordion,
          TabModal,
          TabModalItem,
          Table,
          TableCell,
          TableRow,
          Tabs,
          TabsItem,
          Tag,
          Text,
          TextField,
          Tooltip,
          TooltipToggle,
          UserAgent,
          Video,
          Count,
        }}
        onError={this.handleError}
        showWarnings={config.env !== 'live'}
        renderUnrecognized={(tagName) => config.env !== 'live' && <Notice type="error">Unknown component ${tagName}</Notice>}
        {...this.props}
        jsx={this.props.jsx}
      />
    );
  }
}

export default JsxRenderer;
